import { SourceLocationDTO } from "./apiclient/ApiDtos";
import AppMenuItemData from "./context/AppMenuItemData";
import { SuperAppService } from "./services/SuperAppService";

declare global {
    interface Window {
        superAppService: SuperAppService,
        globalTripDefaultSourceLocations: {
            defaultSourceLocatins: SourceLocationDTO[],
            defaultShuttleSources: SourceLocationDTO[]
        }
    }
}

export function delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function parseAppConfig(rootElem): {
    apiBaseUrls: string[],
    appId: string,
    merchantAppId: string,
    initialLang: string,
    externalMenuItems: AppMenuItemData[],
    smallCarSampleImageUrlPath: string
} | null {
    if (rootElem instanceof Element) {
        if (rootElem.hasAttribute("data-api-base-urls")) {
            let externalMenuItems: AppMenuItemData[] = [];
            if (rootElem.hasAttribute("data-navbar-datalist-id")) {
                const datalistElemId = rootElem.getAttribute("data-navbar-datalist-id");
                if (datalistElemId) {
                    externalMenuItems = parseExternalMenuItems(datalistElemId);
                }
            }

            let apiBaseUrls: string[] = rootElem.getAttribute("data-api-base-urls")!.split(";").map(it => it.trim());

            return {
                apiBaseUrls: apiBaseUrls,
                appId: <string>rootElem.getAttribute("data-app-id"),
                merchantAppId: <string>rootElem.getAttribute("data-merchant-app-id"),
                initialLang: rootElem.getAttribute("data-lang") || "my",
                externalMenuItems: externalMenuItems,
                smallCarSampleImageUrlPath: rootElem.getAttribute("data-small-sample-image-path") || "https://res.cloudinary.com/innoveller/image/upload/v1779702265/mmbusticket/promotion-photos/small-car-sample-5x4.webp"
            }
        }
    }
    return null;
}



export async function selectApiBaseUrl(apiBaseUrls: string[]): Promise<string | null> {
    try {
        //await delay(3000) //just for testing
        const attempts = apiBaseUrls.map(url =>
            checkApiBaseUrl(url).then(ok => {
                if (!ok) throw new Error(`Failed: ${url}`);
                return ok;
            })
        );
        return await Promise.any(attempts);
    } catch (e) {
        console.warn("All API base URLs failed."); //should retry
        return null;
    }
}

export async function checkApiBaseUrl(apiBaseUrl: string): Promise<string | null> {
    try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000); // Scaled back to 10s timeout
        const res = await fetch(`${apiBaseUrl}/health`, { signal: controller.signal });
        clearTimeout(timeout);

        if (res.ok) return apiBaseUrl;
    } catch { }
    return null;
}

function parseExternalMenuItems(datalistElemId: string): AppMenuItemData[] {
    const datalistElem = document.getElementById(datalistElemId);
    if (datalistElem) {
        // Get all the <option> elements within the datalist
        const options = datalistElem.querySelectorAll('option');

        // Convert the options to an array of menu item data
        const menuItems: AppMenuItemData[] = Array.from(options).map(option => {
            return {
                label: {
                    "en": option.getAttribute("data-label-en") || option.innerHTML,
                    "my": option.getAttribute("data-label-my") || option.innerHTML
                },
                href: option.value,
                priority: 1
            }
        });
        return menuItems;
    } else {
        return [];
    }
}


export function disableIOSWebViewZoom(): void {
    const isIOS =
        typeof window !== 'undefined' &&
        (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.maxTouchPoints > 1));

    if (!isIOS) return;

    const preventDefault = (e: Event): void => {
        e.preventDefault();
    };

    document.addEventListener('gesturestart', preventDefault, { passive: false });
    document.addEventListener('gesturechange', preventDefault, { passive: false });
    document.addEventListener('gestureend', preventDefault, { passive: false });

    document.addEventListener(
        'touchstart',
        (e: TouchEvent) => {
            if (e.touches.length > 1) {
                e.preventDefault();
            }
        },
        { passive: false }
    );

    let lastTouchEnd = 0;
    document.addEventListener(
        'touchend',
        (e: TouchEvent) => {
            const now = Date.now();
            if (now - lastTouchEnd <= 300) {
                e.preventDefault();
            }
            lastTouchEnd = now;
        },
        { passive: false }
    );
}